import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserOwner, UserOwnerState } from "./user-owner.model";
import { msalConfig } from "../../config/msalConfig";
import { createAxiosInstance } from "../../utils/axios-instance";
import axios from "axios";
import { USER_AUTH_TYPE } from "../../enums/user-auth-type.enum";
import { setUserProccesing } from "./user-owner.slice";
import { createMsalInstance } from "../../utils/create-msal-instance";

export const getUserOwner = createAsyncThunk(
  '[User Owner] get',
  async (payload: { ownerId: string, employeeId: string }, { rejectWithValue, fulfillWithValue, getState }) => {
    const state = (getState() as { userOwner: UserOwnerState });
    const { ownerId, employeeId } = payload;
    if (state.userOwner.data) {
      return fulfillWithValue(state.userOwner.data);
    }
    try {
      const authority = `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_EMPLOYEE}`;
      msalConfig.auth.authority = authority;
      const msalInstance = await createMsalInstance();
      const axiosInstance = createAxiosInstance(msalInstance);
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_INVITE_API_URL}/rewards/owner/${ownerId}/employee/${employeeId}`,
      );
      const userOwner = res.data as UserOwner;
      localStorage.removeItem("ownerId");
      localStorage.removeItem("employeeId");
      return fulfillWithValue(userOwner);
    } catch (err) {
      const errorMsg = (err as any)?.response?.data?.message || (err as Error)?.message || 'Error fetching user owner';
      return rejectWithValue(errorMsg);
    }
  }
);

export const getEnrollment = createAsyncThunk(
  '[Enrollment] get',
  async (payload: { token: string }, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    const state = (getState() as { userOwner: UserOwnerState });
    const { token } = payload;
    if (state.userOwner.data) {
      return fulfillWithValue(state.userOwner.data);
    }
    try {
      const authority = `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_CUSTOMER}`;
      msalConfig.auth.authority = authority;
      const msalInstance = await createMsalInstance();
      const axiosInstance = createAxiosInstance(msalInstance);

      // Get enrollment data
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_INVITE_API_URL}/rewards/enrollment/${token}`,
      );
      localStorage.removeItem("registrationToken");
      const userOwner = res.data.data as UserOwner;
      const foundProgram = userOwner.programs.find(
        program => program.loyaltyID === `${userOwner.programType}-${userOwner.ownerID}`
      );
      // Retry POST request logic
      // Retry POST request logic
      const MAX_RETRIES = 2;
      let retryCount = 0;
      let postSuccess = false;

      if (foundProgram && !foundProgram.enrolledDate) {
        while (!postSuccess && retryCount <= MAX_RETRIES) {
          try {
            dispatch(setUserProccesing());
            await axiosInstance.post(`${process.env.REACT_APP_INVITE_API_URL}/Rewards/user`, {
              invitationKey: token
            });
            postSuccess = true;
          } catch (err) {
            const apiMessage = (err as any)?.response?.data.message;

            // ✅ If API sent a message, stop retrying and bubble it up immediately
            if (apiMessage) {
              throw apiMessage;
              return rejectWithValue(apiMessage);
            }

            retryCount++;

            if (retryCount > MAX_RETRIES) {
              console.error("Max retries reached for POST request to /Rewards/user");
              throw err; // Let outer catch handle
            }

            // Optional: backoff delay
            await new Promise(resolve => setTimeout(resolve, 5000 * retryCount));
          }
        }
      }

      return fulfillWithValue(userOwner);
    } catch (err) {
      const errorMsg = (err as any)?.response?.data?.message || (err as Error)?.message || 'The invited owner email must match the email that you logged in with. Please reach out to customer service for support.';
      return rejectWithValue(errorMsg);
    }
  }
);
